module.exports = __webpack_public_path__ + "img/3.f0fb1f24.png";